import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import has from '@dojo/framework/core/has';
import { LoadingIndicator } from '@dojo/widgets/loading-indicator';
import { createNlsMiddleware, documentapi, userstate, lccstate } from 'lcc-state';
import { publish } from '@holmescorp/pub-sub';
import { ScoreChart } from '@holmescorp/progress-chart';
import css from '../../css/progress-view.m.css';
import { MicroCardButton, svc, getFinalTestScore, Hero } from '../index';
const factory = create({
    icache: createICacheMiddleware(),
    nls: createNlsMiddleware('ditabook'),
    settingsNls: createNlsMiddleware('settings'),
    theme,
    userstate,
    lccstate,
    documentapi
});
export const FinalTestPanel = factory(({ middleware: { icache, theme, userstate, nls, lccstate, settingsNls } }) => {
    const { messages: { practice_type = 'practice', card_subtitle_quiz_start = '[ditabook] card_subtitle_quiz_start', assess_progress_threshold_high = '80', use_progress_chart_color = 'false' } } = nls();
    const { messages: { title: product_title = '' } } = settingsNls();
    const { get: uget, path: upath } = userstate;
    const { portal_site: site, portal_userid: userid, product: product_id, course_session } = window.hcstatic;
    const session_id = course_session && course_session.pk;
    const themeCss = theme.classes(css);
    const passingScore = parseInt(assess_progress_threshold_high) || 80;
    const useProgressChartColor = use_progress_chart_color === 'true';
    const postTestResults = icache.getOrSet('posttest_results', async () => {
        const member_id = userid || '';
        const data = await svc.attempts_quizzes({
            quiz_type: 'practice',
            member_id,
            product_id,
            session_id,
            site
        });
        return data
            .filter((result) => result.kind === practice_type)
            .flatMap((result) => {
            return result.attempts.map((attempt) => {
                return {
                    score: attempt.score
                };
            });
        });
    });
    const get_tree = (practice_type) => {
        const practiceResults = uget(upath('practice'));
        const posttestResults = uget(upath('posttest'));
        switch (practice_type) {
            case 'practice':
                return practiceResults;
            case 'posttest':
                return posttestResults.tree;
        }
        return {};
    };
    const tree = get_tree(practice_type);
    const ditaroots = lccstate.get(lccstate.path('ditaroots'));
    const fullPosttest = uget(upath('posttest'));
    const { score, hasPosttest } = getFinalTestScore(tree, ditaroots, practice_type, fullPosttest);
    const getHeroContent = (score, scoreHistory) => {
        const hasPassed = score >= passingScore;
        const badgeExtension = has('use-png-badge-logo') ? '.png' : '.svg';
        const bestScore = scoreHistory.reduce((acc, curr) => {
            return Math.max(acc, parseFloat(curr.score));
        }, 0);
        return w(Hero, { additionalClasses: [themeCss.hero] }, [
            v('img', {
                src: `${window.hcstatic.portal_cdn}/js/images/${window.hcstatic.portal_site}/badge${badgeExtension}`,
                alt: `${product_title} Logo Badge`,
                classes: [themeCss.badge]
            }),
            v('div', { classes: [themeCss.center], xqa: 'progress-view-hero-center' }, [
                v('h3', { classes: [themeCss.label] }, [product_title]),
                w(MicroCardButton, {
                    labelText: card_subtitle_quiz_start,
                    showIcon: true,
                    darkMode: !hasPassed,
                    disabled: hasPassed,
                    xqa: 'progress-view-test-button',
                    additionalClasses: [themeCss.quizButton],
                    onClick: () => {
                        publish(`site/${practice_type}`);
                    },
                    onDown: () => {
                        publish(`site/${practice_type}`);
                    }
                })
            ]),
            hasPosttest
                ? v('div', { classes: [themeCss.trailing], xqa: 'progress-view-score-chart' }, [
                    w(ScoreChart, {
                        score,
                        bestScore,
                        useBestScoreIcon: false,
                        bestScoreText: 'Best Test Score',
                        useInsideLabel: true,
                        insideLabelText: 'Test Score',
                        useScoreColor: useProgressChartColor,
                        additionalClasses: [themeCss.small]
                    })
                ])
                : v('div', { xqa: 'progress-view-no-score-chart' }, [])
        ]);
    };
    return postTestResults
        ? getHeroContent(score, postTestResults)
        : w(LoadingIndicator, { active: true, type: 'circular-medium' });
});
export default FinalTestPanel;
